import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from 'common/components/errorBoundary';
import ErrorPage from 'features/errorPage';

const withErrorBoundary = (Component: React.ComponentType): React.FC => () =>
  (
    <ErrorBoundary>
      <Component />
    </ErrorBoundary>
  );

export const Route = createFileRoute('/spaces/404')({
  shouldReload: false,
  component: withErrorBoundary(ErrorPage),
});
